import { Autocomplete, Grid, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { PersonelDetails } from '../../model/create_user';
import { SchemeMaster } from '../../../schemes/models/scheme_master';
import { useNavigate } from 'react-router-dom';
import StepFormActions from '../create_user_shared/step_form_actions';
import RequiredFieldLabel from '../../../../components/required_field_label/required_field_label';

interface props {
    onSubmit: (data: PersonelDetails) => void;
    uid: number | null;
    setUid: (val: number) => void;
    stepperCount: number;
    setStepperCount: (val: number) => void;
    masterDataList: SchemeMaster;
    personalDeatails: PersonelDetails;
    modifyUser?: boolean | undefined;
    disableSaveBtn?: boolean;
    setDisableSaveBtn?: (val: boolean) => void
}

export const subscribeToNewsLetter = [
    { id: 1, value: 'Yes', b_value: true },
    { id: 2, value: 'No', b_value: false },

];

export const ID_PROOF_TYPES = [
    "Aadhaar",
    "PAN",
    "Voter ID",
    "Passport",
    "Driving License",
    "Ration Card",
];

export default function PersonalDetails({
    stepperCount,
    onSubmit: _onSubmit,
    setStepperCount,
    masterDataList,
    personalDeatails,
    modifyUser,
    disableSaveBtn = false,
    setDisableSaveBtn,
}
    : props) {
    const {
        register,
        control,
        handleSubmit,
        setValue,
        watch,
        formState: { errors },
    } = useForm<PersonelDetails>({
        defaultValues: {
            meritalStatus: {
                id: personalDeatails?.meritalStatus?.id!,
                value: personalDeatails?.meritalStatus?.value!
            },
            familyIncome: {
                id: +personalDeatails?.familyIncome?.id!,
                value: personalDeatails?.familyIncome?.value!
            },
            gender: {
                id: personalDeatails?.gender?.id,
                value: personalDeatails?.gender?.value!
            },
            subscribeToNewsLatter: {
                id: personalDeatails?.subscribeToNewsLatter?.id,
                value: personalDeatails?.subscribeToNewsLatter?.value!
            }
        },
    },);
    const navigate = useNavigate();

    const onSubmit: SubmitHandler<PersonelDetails> = (data) => {
        setStepperCount(stepperCount + 1)
        _onSubmit(data);
    }

    useEffect(() => {
        setValue("dob", personalDeatails?.dob)
        setValue("idProofType", personalDeatails?.idProofType)
        setValue("idProofNumber", personalDeatails?.idProofNumber)
        setValue("email", personalDeatails?.email)
        setValue("familyIncome", personalDeatails?.familyIncome)
        setValue("fullName", personalDeatails?.fullName)
        setValue("gender", personalDeatails?.gender)
        setValue("mobileNumber", personalDeatails?.mobileNumber)
        setValue("newsLatterEmailId", personalDeatails?.newsLatterEmailId)
        setValue("subscribeToNewsLatter", personalDeatails?.subscribeToNewsLatter!)
        setValue("meritalStatus", personalDeatails?.meritalStatus!)
    }, [personalDeatails, setValue]);


    const today = new Date().toISOString().split('T')[0];

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container mt={1} spacing={3}>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="fullName"
                        control={control}
                        rules={{
                            required: "Please enter full name",
                            pattern: {
                                value: /^[A-Za-z\s]+$/,
                                message: "Full name should only contain letters"
                            }
                        }}
                        render={({ field: { onChange, value } }) => (
                            <TextField
                                fullWidth
                                label={<RequiredFieldLabel label="Full Name" />}
                                placeholder="Enter full name"
                                value={value}
                                {...register("fullName", {
                                })}
                                error={!!errors.fullName}
                                helperText={errors.fullName?.message}
                                onChange={(e) => {
                                    const newValue = e.target.value.replace(/[^A-Za-z\s]/g, '');
                                    onChange(newValue);
                                    setDisableSaveBtn?.(false)
                                }}
                            />
                        )} />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="dob"
                        control={control}
                        rules={{
                            required: "Please enter date of birth",
                        }}
                        render={({ field: { onChange, value } }) => (
                            <TextField
                                type='date'
                                fullWidth
                                label={<RequiredFieldLabel label="Date of birth" />}
                                placeholder="Please select date of birth"
                                datatype=''
                                {...register("dob", {
                                })}
                                value={value}
                                error={!!errors.dob}
                                helperText={errors.dob?.message}
                                inputProps={{ max: today }}
                                onChange={(e) => { onChange(e); setDisableSaveBtn?.(false) }}
                            />
                        )} />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="gender"
                        control={control}
                        rules={{
                            required: "Please enter gender",
                        }}
                        render={({ field: { onChange, value } }) => (
                            <Autocomplete
                                fullWidth
                                value={value?.value === undefined ? null : value}
                                getOptionLabel={(option) => option.value}
                                renderInput={(params) =>
                                    <TextField {...params}
                                        label={<RequiredFieldLabel label="Gender" />}
                                        error={!!errors.gender}
                                        helperText={errors.gender?.message} />}
                                options={masterDataList?.gender?.filter((item) => item?.value !== "All") || []}
                                onChange={(_, selectedOption) => { onChange(selectedOption); setDisableSaveBtn?.(false) }}

                            />
                        )}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="meritalStatus"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <Autocomplete
                                fullWidth
                                value={value?.value === undefined ? null : value}
                                getOptionLabel={(option) => option.value}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Marital Status (Optional)"

                                    />}
                                options={masterDataList?.maritalStatus.filter((item) => item?.value !== "All") || []}
                                onChange={(_, selectedOption) => { onChange(selectedOption); setDisableSaveBtn?.(false) }
                                }
                            />
                        )}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="email"
                        control={control}
                        rules={{
                            validate: value =>
                                !value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) || "Invalid email address"
                        }}
                        render={({ field: { onChange, value } }) => (
                            <TextField
                                error={!!errors.email}
                                helperText={errors.email?.message}
                                fullWidth
                                label="Email (Optional)"
                                placeholder="Enter Email"
                                value={value}
                                onChange={(e) => { onChange(e); setDisableSaveBtn?.(false) }}
                            />
                        )}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller

                        name="mobileNumber"
                        control={control}
                        rules={{
                            required: "Please enter Mobile number",
                            pattern: {
                                value: /^[0-9]{10}$/,
                                message: "Phone number must be 10 digits long and numeric"
                            }
                        }}
                        render={({ field: { onChange, value } }) => (
                            <TextField
                                disabled={modifyUser}
                                error={!!errors.mobileNumber}
                                helperText={errors.mobileNumber?.message}
                                fullWidth
                                label={<RequiredFieldLabel label="Mobile number" />}
                                placeholder="Enter Mobile number"
                                value={value}
                                onChange={(e) => {
                                    const newValue = e.target.value.replace(/[^0-9]/g, '');
                                    if (newValue.length <= 10) {
                                        onChange(newValue);
                                        setDisableSaveBtn?.(false)
                                    }
                                }}
                                inputProps={{ maxLength: 10 }}

                            />
                        )}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="idProofType"
                        control={control}
                        rules={{
                            validate: value =>
                                !watch("idProofNumber") || !!value || "Please select ID proof type"
                        }}
                        render={({ field: { onChange, value } }) => (
                            <Autocomplete
                                fullWidth
                                value={value || null}
                                renderInput={(params) =>
                                    <TextField {...params}
                                        label="ID Proof Type (Optional)"
                                        error={!!errors.idProofType}
                                        helperText={errors.idProofType?.message} />}
                                options={ID_PROOF_TYPES}
                                onChange={(_, selectedOption) => { onChange(selectedOption); setDisableSaveBtn?.(false) }}
                            />
                        )}
                    />
                </Grid>
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="idProofNumber"
                        control={control}
                        rules={{
                            validate: value =>
                                !watch("idProofType") || !!value || "Please enter ID proof number"
                        }}
                        render={({ field: { onChange, value } }) => (
                            <TextField
                                error={!!errors.idProofNumber}
                                helperText={errors.idProofNumber?.message}
                                fullWidth
                                label="ID Proof Number (Optional)"
                                placeholder="Enter ID proof number"
                                value={value}
                                onChange={(e) => { onChange(e); setDisableSaveBtn?.(false) }}
                            />
                        )}
                    />
                </Grid>
                {/* <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="familyIncome"
                        control={control}
                        rules={{
                            required: "Please select family income",
                        }}
                        render={({ field: { onChange, value } }) => (
                            <Autocomplete
                                fullWidth
                                value={value}
                                getOptionLabel={(option) => option.value}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Family Income"
                                        error={!!errors.familyIncome}
                                        helperText={errors.familyIncome?.message}
                                    />
                                )}
                                options={masterDataList?.familyIncome.filter((item) => !item?.isAggregate) || []}
                                onChange={(_, selectedOption) => onChange(selectedOption)}
                            />
                        )}
                    />
                </Grid> */}
                <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="subscribeToNewsLatter"
                        control={control}
                        rules={{
                            required: "Please select subcribe to news letter",
                        }}
                        render={({ field: { onChange, value } }) => (
                            <Autocomplete
                                fullWidth
                                value={value?.value === undefined ? null : value}
                                getOptionLabel={(option) => option.value}
                                renderInput={(params) => <TextField {...params}
                                    label={<RequiredFieldLabel label="Subscribed to Newsletter" />}
                                    error={!!errors.subscribeToNewsLatter}
                                    helperText={errors.subscribeToNewsLatter?.message} />}
                                options={subscribeToNewsLetter}
                                onChange={(_, selectedOption) => { onChange(selectedOption); setDisableSaveBtn?.(false) }}
                            />
                        )}
                    />
                </Grid>
                {/* <Grid item md={6} lg={6} sm={12} xs={12}>
                    <Controller
                        name="newsLatterEmailId"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <TextField
                                error={!!errors.newsLatterEmailId}
                                helperText={errors.newsLatterEmailId?.message}
                                fullWidth
                                label="Newsletter Email ID"
                                placeholder="Enter Newsletter Email ID"
                                value={value}
                                onChange={onChange}
                            />
                        )}
                    />
                </Grid> */}
                <Grid item md={12} lg={12} sm={12} xs={12}>
                    <StepFormActions
                        showBack={!modifyUser}
                        backLabel="Cancel"
                        onBack={() => navigate('/users')}
                        disabled={disableSaveBtn}
                        submitLabel={!modifyUser ? "Proceed" : "Save Changes"}
                    />
                </Grid>
            </Grid >
        </form>
    )
}
